module.exports = require('../_components/@alicd/next-tree-select/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/tree-select/index.js
// module id = 724
// module chunks = 0